export default "<div class=\"loading\">\r\n  <mdb-spinner spinnerType=\"big\"\r\n               spinnerColor=\"green\"></mdb-spinner>\r\n</div>"